import ListDevicesPage from './ListDevicesPage';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetStoreByIdQuery } from '../../stores/store.api-slice';
import { useParams } from 'react-router-dom';

const ListDevicesForStorePage: React.FC = () => {
  const { id } = useParams();
  const { data } = useGetStoreByIdQuery(id ?? skipToken);

  return <ListDevicesPage merchantStore={data} scope={'merchantStore'} />;
};

export default ListDevicesForStorePage;
